import type { Document } from '@contentful/rich-text-types'

import { SectionComponentLayout } from '../layout/SectionComponentLayout'
import { AnalyticsProvider } from '../providers/AnalyticsProvider'
import { ErrorBoundary } from '../ui/ErrorBoundary'
import { RichText } from '../ui/RichText'
import { articleRichTextOptions } from '../ui/RichText/options/articleRichTextOptions'

export type CountryFooterDisclaimerProps = {
  disclaimer: Document
  hasSpacingTop?: boolean
  hasSpacingHorizontal?: boolean
}

export function CountryFooterDisclaimer({
  disclaimer,
  hasSpacingTop = true,
  hasSpacingHorizontal = true,
}: CountryFooterDisclaimerProps) {
  return (
    <ErrorBoundary>
      <AnalyticsProvider analyticsPrefix="CountryFooterDisclaimer">
        <SectionComponentLayout
          hasSpacingTop={hasSpacingTop}
          hasSpacingHorizontal={hasSpacingHorizontal}
        >
          <RichText
            content={disclaimer}
            richTextOptions={articleRichTextOptions}
          />
        </SectionComponentLayout>
      </AnalyticsProvider>
    </ErrorBoundary>
  )
}
